import type { DevToolsTone } from 'Modules/softphone/components/SoftphoneDevTools/index.types';

const HEALTHY_ICE = ['connected', 'completed'];
const PENDING_ICE = ['new', 'checking'];

/** No connection is not the same as a bad one, so no state reads as no signal. */
export const toneForIce = (
  state: RTCIceConnectionState | null
): DevToolsTone => {
  if (!state) {
    return 'muted';
  }

  if (HEALTHY_ICE.includes(state)) {
    return 'ok';
  }

  return PENDING_ICE.includes(state) ? 'warn' : 'bad';
};

/** Loss, jitter and round-trip all read the same way: lower is better. */
export const byThreshold = (
  value: number,
  warnAbove: number,
  badAbove: number
): DevToolsTone => {
  if (value < warnAbove) {
    return 'ok';
  }

  return value < badAbove ? 'warn' : 'bad';
};

/**
 * Silence on a connected call is itself a finding, so 0 is not "ok".
 *
 * With no connection there is nothing to be silent about, hence `muted`.
 */
export const toneForBitrate = (
  kbps: number,
  ice: RTCIceConnectionState | null
): DevToolsTone => {
  if (kbps > 0) {
    return 'ok';
  }

  return HEALTHY_ICE.includes(ice ?? '') ? 'warn' : 'muted';
};
